import React, { useEffect, useState } from "react";
import "./App.css";
import { Header } from "./components";
import Home from "./components/home/Home";
import About from "./components/about/About";
import Skills from "./components/skills/Skills";
import BackendLab from "./components/BackendLab/BackendLab";
import Services from "./components/services/Services";
import Qualification from "./components/qualification/Qualification";
import Testimonials from "./components/testimonials/Testimonials";
import Contact from "./components/contact/Contact";
import Footer from "./components/footer/Footer";
import Scrollup from "./components/scrollup/Scrollup";
import Portfolio from "./components/portfolio/Portfolio";
import logo from "./logo.png";

function App() {
  const [isLoading, setIsLoading] = useState(true);

  // ✅ Best fix: never rely solely on window "load" (can hang on Android).
  // - If document is already complete, stop immediately
  // - Otherwise: listen for load + force a timeout fallback so it never gets stuck
  useEffect(() => {
    const done = () => setIsLoading(false);

    if (document.readyState === "complete") {
      done();
      return;
    }

    const timeoutId = setTimeout(done, 3500); // fallback release
    window.addEventListener("load", done, { once: true });

    return () => {
      clearTimeout(timeoutId);
      window.removeEventListener("load", done);
    };
  }, []);

  // ✅ Upgrade: safer hash scrolling (querySelector can break on some hashes)
  useEffect(() => {
    const hash = window.location.hash;
    if (!hash) return;

    const id = decodeURIComponent(hash.slice(1));

    const t = setTimeout(() => {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 250);

    return () => clearTimeout(t);
  }, []);

  if (isLoading) {
    return (
      <div className="loader-container" role="status" aria-live="polite" aria-busy="true">
        <div className="loader-content">
          <img
            src={logo}
            alt="Company Logo"
            className="loader-logo"
            loading="eager"
            decoding="async"
          />
          <div className="loader">Loading...</div>
        </div>
      </div>
    );
  }

  return (
    <>
      <Header />
      <main className="main" id="top">
        <Home />
        <About />
        <Skills />
        <BackendLab />
        <Services />
        <Qualification />
        <Testimonials />
        <Portfolio />
        <Contact />
      </main>
      <Footer />
      <Scrollup />
    </>
  );
}

export default App;
